'use client';

import { c as _c } from "react/compiler-runtime";
import { SidebarMenuButton, SidebarMenuItem } from '@repo/ui/components';
import { usePathname } from 'next/navigation';
import { PrefetchLink } from '@/app/@protected/_components/prefetch-link.tsx';
import { SidebarItem } from '@/app/@protected/_components/sidebar/sidebar-content.tsx';
import { usePrefetchLoadsList } from '@/app/@protected/loads/(table)/_hooks/use-prefetch-loads-list.ts';
import { usePrefetchFirstCompaniesPage } from '@/app/@protected/management/_hooks/use-prefetch-first-companies-page.ts';
export const LinkMenu = item => {
  const $ = _c(23);
  const path = usePathname();
  let t0;
  if ($[0] !== item.url) {
    t0 = item.url.trim();
    $[0] = item.url;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isDisabled = t0 === "";
  const isActive = !isDisabled && path === item.url;
  const prefetchLoads = usePrefetchLoadsList();
  const prefetchCustomers = usePrefetchFirstCompaniesPage("shipper");
  const prefetchCarriers = usePrefetchFirstCompaniesPage("haulier");
  const prefetchOtherCompanies = usePrefetchFirstCompaniesPage("other");
  let t1;
  if ($[2] !== isDisabled || $[3] !== item.url || $[4] !== prefetchCarriers || $[5] !== prefetchCustomers || $[6] !== prefetchLoads || $[7] !== prefetchOtherCompanies) {
    t1 = () => {
      if (isDisabled) {
        return;
      }
      if (item.url === "/loads" || item.url.startsWith("/loads/")) {
        prefetchLoads();
      } else {
        if (item.url.includes("/customers")) {
          prefetchCustomers();
        } else {
          if (item.url.includes("/carriers")) {
            prefetchCarriers();
          } else {
            if (item.url.includes("/other-companies")) {
              prefetchOtherCompanies();
            }
          }
        }
      }
    };
    $[2] = isDisabled;
    $[3] = item.url;
    $[4] = prefetchCarriers;
    $[5] = prefetchCustomers;
    $[6] = prefetchLoads;
    $[7] = prefetchOtherCompanies;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  const handleMouseEnter = t1;
  let t2;
  if ($[9] !== handleMouseEnter || $[10] !== isDisabled || $[11] !== item.url) {
    t2 = isDisabled ? <button aria-disabled="true" className="cursor-not-allowed opacity-50" disabled={true} type="button" /> : <PrefetchLink href={item.url} onMouseEnter={handleMouseEnter} />;
    $[9] = handleMouseEnter;
    $[10] = isDisabled;
    $[11] = item.url;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  let t3;
  if ($[13] !== item.icon) {
    t3 = item.icon && <item.icon />;
    $[13] = item.icon;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  let t4;
  if ($[15] !== item.title) {
    t4 = <span>{item.title}</span>;
    $[15] = item.title;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== isActive || $[18] !== item.title || $[19] !== t2 || $[20] !== t3 || $[21] !== t4) {
    t5 = <SidebarMenuItem data-sentry-element="SidebarMenuItem" data-sentry-component="LinkMenu" data-sentry-source-file="link-menu.tsx"><SidebarMenuButton isActive={isActive} render={t2} tooltip={item.title} data-sentry-element="SidebarMenuButton" data-sentry-source-file="link-menu.tsx">{t3}{t4}</SidebarMenuButton></SidebarMenuItem>;
    $[17] = isActive;
    $[18] = item.title;
    $[19] = t2;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  return t5;
};